<template>
  <div class="header-area">
    <div class="new-header">
      <div class="header-left-side">
        <i v-if="isHideSidebar" class="material-icons-outlined open-sidebar-icon"
          @click="expandSideBarAction">expand_circle_down</i>

        <nav class="header-wg-tabs">
          <router-link
            to="/sites"
            class="header-wg-tabs__tab"
            active-class="header-wg-tabs__tab--active"
            exact
          >
            My projects
          </router-link>
          <!-- POP Authority: the setup fee (audit) is part of the project setup, never ordered from here -->
          <router-link
            v-if="hasSiteContext && !isPopAuthorityUser"
            :to="{ name: 'OrderContentAuditWhiteGlove', params: { siteId: String($route.params.siteId) } }"
            class="header-wg-tabs__tab header-wg-tabs__tab--pill header-wg-tabs__tab--pill-first"
            active-class="header-wg-tabs__tab--active"
          >
            <i class="material-icons header-wg-tabs__pill-icon">add</i>
            Order content audit
          </router-link>
          <button
            v-else-if="!isPopAuthorityUser"
            type="button"
            class="header-wg-tabs__tab header-wg-tabs__tab--as-tab header-wg-tabs__tab--pill header-wg-tabs__tab--pill-first"
            @click="openSitePickerForOrder('OrderContentAuditWhiteGlove')"
          >
            <i class="material-icons header-wg-tabs__pill-icon">add</i>
            Order content audit
          </button>
          <!-- POP Authority: the monthly package is reached from the "POP Authority" button on the right (design TopBar) -->
          <router-link
            v-if="hasSiteContext"
            :to="{ name: 'OrderContentOnlyWhiteGlove', params: { siteId: String($route.params.siteId) } }"
            class="header-wg-tabs__tab header-wg-tabs__tab--pill"
            :class="{ 'header-wg-tabs__tab--pill-first': isPopAuthorityUser }"
            active-class="header-wg-tabs__tab--active"
          >
            <i class="material-icons header-wg-tabs__pill-icon">add</i>
            Order content only
          </router-link>
          <button
            v-else
            type="button"
            class="header-wg-tabs__tab header-wg-tabs__tab--as-tab header-wg-tabs__tab--pill"
            :class="{ 'header-wg-tabs__tab--pill-first': isPopAuthorityUser }"
            @click="openSitePickerForOrder('OrderContentOnlyWhiteGlove')"
          >
            <i class="material-icons header-wg-tabs__pill-icon">add</i>
            Order content only
          </button>
          <!-- POP Authority: booster packs (design TopBar "Order booster pack" pill) -->
          <router-link
            v-if="isPopAuthorityUser && hasSiteContext"
            :to="{ name: 'PopAuthorityBoosters', params: { siteId: String($route.params.siteId) } }"
            class="header-wg-tabs__tab header-wg-tabs__tab--pill"
            active-class="header-wg-tabs__tab--active"
          >
            <i class="material-icons header-wg-tabs__pill-icon">bolt</i>
            Order booster pack
          </router-link>
          <button
            v-else-if="isPopAuthorityUser"
            type="button"
            class="header-wg-tabs__tab header-wg-tabs__tab--as-tab header-wg-tabs__tab--pill"
            @click="openSitePickerForOrder('PopAuthorityBoosters')"
          >
            <i class="material-icons header-wg-tabs__pill-icon">bolt</i>
            Order booster pack
          </button>
        </nav>
      </div>
      <div class="buttons-area">
        <div class="action-buttons-area">
          <v-btn v-if="[
              'Sites', 'Campaign',
              'ProjectLevelWorkStation', 'PageLevelWorkStation', 'ProgressNotes'
            ].includes($route.name)"
            rounded small color="profileAnchorColor"
            class="button-with-icon whiteColor--text text-none"
            :disabled="$store.getters.isDemoUser"
            :to="`/newsite`">
            <i class="material-icons">add</i>
            <span>New project</span>
          </v-btn>
          <v-btn v-else :disabled="$store.getters.isDemoUser" rounded small color="profileAnchorColor"
            class="button-with-icon whiteColor--text text-none"  :to="`/newsite`">
            <i class="material-icons">add</i>
            <span>New project</span>
          </v-btn>

          <!-- POP Authority packages (design TopBar: outline pill next to "New project") -->
          <router-link
            v-if="isPopAuthorityUser"
            :to="popAuthorityPackagesTo"
            class="header-pa-btn"
            :class="{ 'header-pa-btn--active': $route.name === 'PopAuthorityPackages' }"
          >
            POP Authority
          </router-link>

          <div class="modal" :class="{ 'is-active': sitePickerModalOpen }">
            <div class="modal-background" @click.stop="closeSitePickerModal"></div>
            <div class="modal-content" style="max-width: 450px;">
              <div class="box modal-container" style="padding: 40px; background-color: var(--v-topHeaderBg-base);">
                <p class="title-font is-size-5 mainColor--text mt-1 mb-7">{{ sitePickerHeading }}</p>
                <template v-if="availableSites.length">
                  <div class="subtitle-font mainColor--text mb-3">Project</div>
                  <v-autocomplete
                    class="mb-6 choose-project-autocomplete"
                    outlined
                    placeholder="Choose a project"
                    append-icon="keyboard_arrow_down"
                    v-model="pickerSelectedSiteId"
                    :items="availableSites"
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  />
                </template>
                <div class="d-flex gap10 mt-2">
                  <div style="flex: 1;">
                    <v-btn
                      rounded
                      outlined
                      block
                      color="profileAnchorColor"
                      class="button-with-sicon mainColor--text text-none"
                      style="height: 45px;"
                      @click.stop="closeSitePickerModal"
                    >
                      <span style="font-size: 1rem;">Cancel</span>
                    </v-btn>
                  </div>
                  <div style="flex: 1;">
                    <v-btn
                      v-if="availableSites.length"
                      rounded
                      block
                      color="profileAnchorColor"
                      class="button-with-sicon whiteColor--text text-none ml-2"
                      :disabled="!pickerSelectedSiteId"
                      style="height: 45px;"
                      @click.stop="confirmSitePicker"
                    >
                      <span style="font-size: 1rem;">Continue</span>
                    </v-btn>
                    <v-btn v-else rounded block color="profileAnchorColor" class="button-with-sicon whiteColor--text text-none ml-2" style="height: 45px;" :to="`/newsite`">
                      <span style="font-size: 1rem;">Create a project</span>
                    </v-btn>
                  </div>
                </div>
              </div>
              <button class="custom-modal-close-btn" aria-label="close" @click="closeSitePickerModal">
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>

          <div class="modal" :class="{ 'is-active': getModalDataState.value }">
            <div class="modal-background" @click.stop="closeAction()"></div>
            <div class="modal-content">
              <div class="box modal-container" style="overflow: hidden;">
                <div>
                  <div class="title-font is-size-5 mb20 mainColor--text">
                    <div class="subtitle-font mainColor--text">
                      {{ getModalDataState.schemaType }} schema report is ready
                    </div>
                  </div>
                  <div class="control flex ">
                    <div class="flex-grow-1"></div>
                    <v-btn rounded color="profileAnchorColor" class="button-with-button text-none whiteColor--text"
                      @click="navigate()">
                      Go to page
                    </v-btn>
                    <v-btn rounded color="profileAnchorColor" class="button-with-button text-none whiteColor--text"
                      @click="closeAction()">
                      Close
                    </v-btn>
                  </div>
                </div>
              </div>
              <button class="custom-modal-close-btn" aria-label="close" @click="closeAction()">
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>

          <balance-header-item style="margin-right: 10px;" />

          <content-orders-cart />

        </div>

        <div>
          <div class="dropdown is-right is-hoverable custom-dropdown-menu ml-3">
            <div class="dropdown-trigger">
              <a class="d-flex align-center" aria-haspopup="true" aria-controls="dropdown-menu">
                <div class="profile-logo">
                  <i class="material-icons person-icon" style="font-size: 1.8rem;">account_circle</i>
                </div>
                <div class="d-flex align-center mainColor--text">
                  <i class="material-icons">expand_more</i>
                </div>
              </a>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <div class="mainColor--text info-area flex align-center">
                  <span class="mr5">
                    <div class="profile-logo">
                      <i class="material-icons person-icon">account_circle</i>
                    </div>
                  </span>
                  <div class="flex-grow-1">
                    <div class="email-label">
                      {{ $store.getters.isDemoUser ? "Demo User" : user.email }}
                    </div>
                    <div
                      v-if="!$store.getters.isDemoUser"
                      class="font-weight-bold darkGrayColor--text"
                    >
                      <div
                        v-for="(text, idx) in accountBalanceLabels"
                        :key="idx"
                      >
                        {{ text }}
                      </div>
                    </div>
                    <div
                      class="flex font-weight-bold"
                      v-if="isUnlimitedUser && !$store.getters.isDemoUser"
                    >
                      <span class="darkGrayColor--text"> Reports limit: </span>
                      <span class="profileAnchorColor--text"
                        >&nbsp;Unlimited</span
                      >
                    </div>
                  </div>
                </div>

                <template v-if="!$store.getters.isDemoUser">
                  <router-link v-if="isAdmin" :to="`/admin/${user.id}`" class="dropdown-item">
                    <span class="material-icons-outlined">admin_panel_settings</span>
                    Admin
                  </router-link>

                  <router-link v-if="user && user.id" class="dropdown-item" :to="`/useraccount/${user.id}`">
                    <span class="material-icons-outlined">manage_accounts</span>
                    Account settings
                  </router-link>
                  <router-link v-if="isWhiteGloveUser" to="/white-glove-orders" class="dropdown-item">
                    <span class="material-icons-outlined">receipt_long</span>
                    {{ $store.getters.isPopAuthorityUser ? 'POP Authority orders' : 'White Glove orders' }}
                  </router-link>
                  <router-link
                    v-if="isPopAuthorityUser && user && user.id"
                    :to="`/useraccount/${user.id}?mainTab=billing-and-payments&subTab=pop-authority-packages`"
                    class="dropdown-item"
                  >
                    <span class="material-icons-outlined">workspace_premium</span>
                    POP Authority packages
                  </router-link>
                  <router-link to="/ai-writer-log" class="dropdown-item">
                    <span class="material-icons-outlined">auto_fix_high</span>
                    AI articles dashboard
                  </router-link>
                  <router-link v-if="hasApiDashboardAccess" to="/api-usage-dashboard" class="dropdown-item">
                    <span class="material-icons-outlined">stacked_bar_chart</span>
                    API usage dashboard
                  </router-link>
                  <router-link v-if="hasOwnerAccounts" :to="`/useraccount/${user.id}?mainTab=switch-account`"
                    class="dropdown-item">
                    <span class="material-icons-outlined">sync_alt</span>
                    Switch account
                  </router-link>
                  <router-link class="dropdown-item" :to="`/admin/${user.id}`" v-if="isAffiliate">
                    <span><i class='material-icons'>currency_exchange</i></span>
                    Affiliate Dashboard
                  </router-link>
                  <a target="_blank" href="https://academy.pageoptimizer.pro/" class="dropdown-item">
                    <span class="material-icons-outlined">playlist_add_check_circle</span>
                    POP Academy
                  </a>
                  <a class="dropdown-item" target="_blank" :href="`https://help.pageoptimizer.pro/`">
                    <span class="material-icons-outlined">live_help</span>
                    Help centre
                  </a>
                  <a class="dropdown-item" target="_blank"
                    :href="`https://pageoptimizer.pro/pageoptimizer-pro-chrome-extension-guide/`">
                    <span class="material-icons-outlined">extension</span>
                    POP chrome extension
                  </a>
                </template>
                <hr class="dropdown-divider">
                <a @click.stop="logout" class="dropdown-item signout-item">
                  <span>Sign out</span>
                  <i class='fa fa-sign-out'></i>
                </a>

                <!-- <div>
                <a class="dropdown-item has-sub-account">
                  <span class="icon is-small">
                    <i class='fa fa-medkit'></i>
                  </span>
                  Services
                </a>
                <div class="sub-menu">
                  <ul>
                    <li>
                      <a class="dropdown-item" href="https://pageoptimizer.pro/done-for-you/" target="_blank">
                        <span class="icon is-small">
                          <i class='fa fa-link'></i>
                        </span>
                        Done For You
                      </a>
                    </li>
                  </ul>
                </div>
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <insufficient-fund-modal ref="insufficientFundModal" />
    </div>
  </div>
</template>


<script>
import InsufficientFundModal from '@/components/InsufficientFundModal.vue'
import { mixin } from '@/components/mixin'
import { mixin as ServiceMixin } from '@/components/service_mixin'
import { mixin as notificaitons_mixin } from '@/components/mixins/common_notifies';
import { DEMO_SESSION_KEYS } from "@/components/PageRun/constants";
import ContentOrdersCart from '@/components/Campaigns/content-orders/ContentOrdersCart.vue'
import { getPureServicePkgName } from '@/utils'
import { whiteGlovePlans } from "@/components/plans_constants"
import BalanceHeaderItem from '@/components/Campaigns/balance/BalanceHeaderItem.vue'

export default {
  name: 'NewHeader',
  mixins: [mixin, ServiceMixin, notificaitons_mixin,],
  components: { InsufficientFundModal, ContentOrdersCart, BalanceHeaderItem },
  data() {
    return {
      sitePickerModalOpen: false,
      sitePickerRouteName: null,
      pickerSelectedSiteId: null,
    };
  },
  computed: {
    hasSiteContext() {
      return Boolean(this.$route.params.siteId);
    },
    isPopAuthorityUser() {
      return Boolean(this.$store.getters.isPopAuthorityUser);
    },
    availableSites() {
      return this.$store.getters.getSiteData || [];
    },
    /**
     * "POP Authority" button target: the open project's packages page; outside a project the page
     * opens with the "Subscribe for project" selector (design PackageChooser fromAccount).
     */
    popAuthorityPackagesTo() {
      if (this.hasSiteContext) {
        return { name: 'PopAuthorityPackages', params: { siteId: String(this.$route.params.siteId) } };
      }
      const first = this.availableSites[0];
      if (!first) return '/newsite';
      return { name: 'PopAuthorityPackages', params: { siteId: String(first.id) }, query: { from: 'account' } };
    },
    sitePickerHeading() {
      if (this.sitePickerRouteName === 'OrderContentAuditWhiteGlove') {
        return 'Order content audit';
      }
      if (this.sitePickerRouteName === 'OrderContentOnlyWhiteGlove') {
        return 'Order content only';
      }
      if (this.sitePickerRouteName === 'PopAuthorityBoosters') {
        return 'Order booster pack';
      }
      return 'Select a project';
    },
    getModalDataState() {
      return this.$store.getters.getModalData;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    user() {
      return this.$store.state.user
    },
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.user
    },
    hasApiDashboardAccess () {
      return this.$store.getters.hasApiDashboardAccess
    },
    hasPOPApiKey () {
      return this.$store.getters.hasPOPApiKey
    },
    isWatchdogOnlyUser() {
      return this.$store.getters.isWatchdogOnlyUser
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    isHideSidebar() {
      return this.$store.state.isHideSidebar
    },
    availableReportCreditsOfUserOrTeam() {
      return this.$store.getters.availableReportCreditsOfUserOrTeam
    },
    canCreateNewPage() {
      if (this.availableReportCreditsOfUserOrTeam >= 2) {
        return true;
      }
      return false;
    },
    canCreateRerun() {
      if (this.availableReportCreditsOfUserOrTeam >= 1) {
        return true;
      }
      return false;
    },
    currentSiteId() {
      if (this.$route.params.siteId) {
        return this.$store.state.currentSiteId
      }
      return ''
    },
    isAffiliate() {
      if (this.user) {
        return this.user.isAffiliate
      }
      return false
    },
    isPartnershipApiKeyAllowed() {
      return this.$store.getters.isPartnershipApiKeyAllowed
    },
    site() {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId))
    },
    page() {
      if (!this.site || !this.site.pages.length) {
        return {}
      }
      return this.site.pages.find((p) => p.id === parseInt(this.$route.params.pageId))
    },
    accountBalanceLabels() {
      if (!this.user || this.isWhiteGloveUser) {
        return ['', '']
      }
      return this.getAccountBalanceLabel(this.ownerUser)
    },
  },
  methods: {
    expandSideBarAction() {
      this.$store.commit('setIsUserClosedSideBar', false)
      this.$store.commit('setHideSideBar', false)
    },
    changeTopBarVisibility(payload) {
      this.$store.commit('setHideTopBar', payload)
    },
    addPage() {
      if (this.isWatchdogOnlyUser) {
        this.showCanNotCreatePageBecauseYouWatchdogUserNotification();
        return;
      }
      if (this.canCreateNewPage) {
        this.errMsg = ''
        this.$router.push(`/sites/${this.site.id}/newpage`)
      } else {
        this.$refs.insufficientFundModal.show()
        this.errMsg = 'Insufficient report balance to create a page.  Please purchase more reports in your user profile dashboard.'
      }
    },
    makeRerunAnalysis() {
      if (this.canCreateRerun) {
        this.errMsg = ''
        this.rerunAnalysis()
      } else {
        this.$refs.insufficientFundModal.show()
        this.errMsg = 'Insufficient report balance to create a page.  Please purchase more reports in your user profile dashboard.'
      }
    },
    gotoBulkProjectPage() {
      if (!this.isAgencyUnlimitedUser) { return }
      this.$router.push('/new-bulk-run')
    },
    logout() {
      Object.values(DEMO_SESSION_KEYS).forEach(key => sessionStorage.removeItem(key))
      this.$store.commit('clearStore')
      this.$router.push('/login')
    },
    navigate() {
      let filePath = this.getModalDataState.currentLocation;
      if (filePath.startsWith("#")) {
        filePath = filePath.slice(1);
      }
      this.$router.push(filePath)
      this.$store.commit('setPopUpModal', { pageRunId: this.getModalDataState.pageRunId, currentLocation: '', value: false, schemaType: this.getModalDataState.schemaType })
    },
    closeAction() {
      this.$store.commit('setPopUpModal', { pageRunId: this.getModalDataState.pageRunId, currentLocation: '', value: false, schemaType: this.getModalDataState.schemaType })
    },
    openSitePickerForOrder(routeName) {
      this.sitePickerRouteName = routeName;
      this.pickerSelectedSiteId = null;
      this.sitePickerModalOpen = true;
    },
    closeSitePickerModal() {
      this.sitePickerModalOpen = false;
      this.sitePickerRouteName = null;
      this.pickerSelectedSiteId = null;
    },
    confirmSitePicker() {
      if (!this.pickerSelectedSiteId || !this.sitePickerRouteName) return;
      this.$router.push({
        name: this.sitePickerRouteName,
        params: { siteId: String(this.pickerSelectedSiteId) },
      });
      this.closeSitePickerModal();
    },
  },
  watch: {
    // Watch for changes in modalData
    getModalDataState: {
      handler(newVal) {
        console.log('modalData changed', newVal);
      }
    }
  },

}
</script>
<style lang="scss">
.button-with-icon {

  i,
  span {
    font-weight: normal;
  }
}

.not-allowed-cursor {
  cursor: not-allowed;
  font-size: 1rem;
  color: var(--v-mainColor-base);
  font-weight: 700;
  cursor: pointer;
}

.header-area {
  position: relative;
  border-bottom: 1.5px solid var(--v-gray12Color-base);
}

.fold-icon {
  font-size: 1rem;
  color: var(--v-profileAnchorColor-base);
}

.open-sidebar-icon {
  font-size: 1.5rem;
  color: var(--v-mainColor-base);
  transform: rotate(-90deg);
  cursor: pointer;
}

.is-white-glove {
  .new-header {
    padding: 0px;
  }
}

.new-header {
  display: flex;
  align-items: center;
  margin: 0px;

  /* border-bottom: 1px solid white; */
  flex-wrap: wrap;

  .buttons-area {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;

    .action-buttons-area {
      flex-grow: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
      gap: 5px;
    }

    .action-buttons-on-mobile {
      flex-grow: 1;
      display: none;
    }
  }


  .back-to-home {
    color: var(--v-mainColor-base)
  }

  .project-name {
    color: var(--v-mainColor-base)
  }

  .bulk-run-button {
    background: #fffaf2;
    border: 1px solid #ffebcc;
    color: black;
  }

  .custom-dropdown-menu {
    .dropdown-menu {
      width: 300px !important;

      .dropdown-content {
        border-radius: 10px !important;
          background: var(--v-cardBg-base);
          max-height: calc(100vh - 100px);
          overflow: auto;
      }
    }

    .has-sub-account {
      cursor: default;
      color: grey;

      &:hover {
        background: none;
      }

      /* &:hover + .sub-menu,
        & .sub-menu:hover {
          background: red;
          display: block;
        } */
    }

    .sub-menu {
      text-align: left;
      padding-left: 15px;
    }

    /* .dropdown-item, .dropdown .dropdown-menu .has-link a {
        font-size: 16px !important;
      } */
  }

  .dropdown-content {
    .email-label {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 6px;
      overflow-wrap: anywhere;
      color: var(--v-mainColor-base);
    }
  }

  .dropdown-item {
    padding: 10px 10px 10px 20px;
    display: flex;
    align-items: center;
    font-size: 14px;

    img {
      width: 14px;
      height: 15px;
    }

    img.upgrade_img {
      margin-left: 1rem;
      width: 70px;
      height: 20px;
    }

    i,
    span {
      font-size: 1.2rem;
    }

    &> :first-child {
      width: 33px;
    }
  }

  .signout-item {
    display: flex;
    padding-left: 50px;
    padding-right: 25px;
    color: var(--v-profileAnchorColor-base);

    &>span:first-child {
      flex-grow: 1;
    }

    i {
      font-size: 1rem;
    }
  }

  .profile-logo {
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;

    i {
      font-size: 2.8rem;
      color: #7895A7;
    }
  }

  .dropdown-menu .profile-logo {
    margin: 0 11px 0px 20px;
  }

  .info-area {
    padding: 10px 5px 10px 0px;
  }

  /* @media screen and (max-width: 600px) {
      .navbar-item {
        &.has-dropdown {
          .navbar-dropdown {
            display: none;
          }
          &.is-active {
            .navbar-dropdown {
              display: block;
            }
          }
        }
      }
    } */
}

.light-darm-menu {
  padding: 10px 10px 10px 20px; 
  .light-dark-switch-area {
    margin-top: 10px;
    display: flex;
    gap: 15px;
    & > div {
      cursor: pointer;
      position: relative;
      & > div {
        display: flex;

        & {
          border: 2px solid transparent;
        }
        &.is-active {
          border-radius: 5px;
          border: 2px solid var(--v-profileAnchorColor-base);
          &::before {
            position: absolute;
            display: inline-block;
            font-family: 'Material Icons';
            content: '\e86c';
            color: var(--v-green21Color-base);
            font-size: 1rem;
            top: 5px;
            right: 5px;
            
          }
        }
      }
      
      .mode-img {
        width: 80px;
        height: auto;
        
      }
      .mode-label {
        color: var(--v-mainColor-base);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.header-left-side {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-wg-tabs {
  display: flex;
  gap: 0;
  align-items: center;
}

.header-wg-tabs__tab {
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: 600;
  color: var(--v-mainColor-base);
  text-decoration: none;
  border-bottom: 3px solid transparent;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: var(--v-profileAnchorColor-base);
  }

  &--active {
    color: var(--v-profileAnchorColor-base);
    background-color: #FFEDDD;
    border-bottom-color: var(--v-profileAnchorColor-base);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    font-weight: 700;
  }

  &--as-tab {
    appearance: none;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    font-family: inherit;
    margin: 0;
    text-align: center;
  }

  &--pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 28px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-left: 10px;
    color: var(--v-profileAnchorColor-base);
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1;
    transition: background-color 0.15s, border-color 0.15s, color 0.15s;

    &.header-wg-tabs__tab--active,
    &:hover,
    &:focus-visible {
      color: var(--v-profileAnchorColor-base);
      background-color: #FFE5CE;
      border-color: var(--v-profileAnchorColor-base);
      border-bottom-width: 1px;
      border-radius: 999px;
      font-weight: 700;
    }
  }

  &--pill-first {
    position: relative;
    margin-left: 40px;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -20px;
      width: 1px;
      height: 18px;
      background-color: var(--v-gray12Color-base);
      transform: translateY(-50%);
    }
  }
}

.header-wg-tabs__pill-icon {
  font-size: 16px;
  line-height: 1;
}

/* design pa.css .pa-btn.out.pillr: 34px outline pill, teal text, box background on hover */
.header-pa-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 16px;
  margin-left: 5px;
  border-radius: 999px;
  border: 1px solid var(--v-grayColor-base, #ccc);
  background: #fff;
  color: var(--v-mainColor-base);
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  transition: background 0.15s;

  &:hover,
  &--active {
    background: var(--v-gray7Color-base, #f7f7f7);
    color: var(--v-mainColor-base);
  }
}

.choose-project-autocomplete {
  ::v-deep {
    .v-input__control {
      fieldset {
        border: 1px solid var(--v-grayColor-base) !important;
        background-color: var(--v-whiteColor-base) !important;
      }
      input {
        font-size: 0.9rem !important;
      }
    }
  }
}
</style>
